module.exports = __webpack_public_path__ + "static/media/calibri-7.a78cfad3.ttf";